<script lang="ts" setup>
import RouteStopIcon from "@/components/routeStop/RouteStopIcon.vue";
import RouteStopTime from "@/components/routeStop/RouteStopTime.vue";
import type { TruckRouteStop } from "@/api/trucks/dto/truck.dto";

const props = defineProps<{
  routeStop: TruckRouteStop;
}>();
</script>

<template>
  <div>
    <div class="d-flex align-center">
      <route-stop-icon :type="props.routeStop.type" class="mr-2" />
      <router-link
        :to="{ name: 'facilities-edit', params: { id: props.routeStop.facilityId } }"
        class="text-primary font-weight-500 text-decoration-none"
        data-qa="next-stop-facility-name"
        target="_blank"
      >
        {{ props.routeStop.facility?.name }}
      </router-link>
    </div>

    <div class="text-grey-darken-2 mt-2">{{ routeStop.facility?.address }}</div>

    <route-stop-time
      :stop-timezone="props.routeStop.timezone"
      :time-to="props.routeStop.timeTo"
      :time-type="props.routeStop.timeType"
      class="mt-2"
    />
  </div>
</template>

<style lang="scss" scoped></style>
